<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <div>
    <v-tooltip bottom color="pink">
      <template v-slot:activator="{ on }">
        <v-switch
          v-on="on"
          v-model="showLog"
          label="Show Exponential Trend"
          hide-details
          class="mt-0 mb-1"
          color="pink"
          dense
        ></v-switch>
      </template>
      A log scale flattens out an exponential trend and makes it easier to see how it is progressing
    </v-tooltip>
    <GlobalCompLinear v-show="!showLog" ref="GlobalCompLinear"></GlobalCompLinear>
    <GlobalCompLog v-show="showLog" ref="GlobalCompLog"></GlobalCompLog>
  </div>
</template>

<script>
import GlobalCompLinear from "@/components/graphs/GlobalCompLinear.vue";
import GlobalCompLog from "@/components/graphs/GlobalCompLog.vue";

export default {
  name: "GlobalComp",
  components: {
    GlobalCompLinear,
    GlobalCompLog
  },
  data: () => ({
    showLog: false
  }),
  watch: {
    showLog: function(val) {
      this.resize();
    }
  },
  methods: {
    loadGlobalStats(globalConfirmedData,continents) {
      this.$refs.GlobalCompLinear.loadGlobalStats(
        globalConfirmedData,
        continents
      );
      this.$refs.GlobalCompLog.loadGlobalStats(
        globalConfirmedData,
        continents
      );
    },
    resize() {
      this.$refs.GlobalCompLinear.resize();
      this.$refs.GlobalCompLog.resize();
    }
  }
};
</script>
